export default "__VITE_ASSET__BPpNmHje__"